import { get } from 'lodash';
import React, { useState } from 'react';

import ProcessDiscoveryEmbedModal from './ProcessDiscoveryButton/ProcessDiscoveryEmbedModal';
import { ApplicationDescriptor, hasEmbeddedExecutionMethod } from './helpers/processDiscoveryHelper';
import { ActionsConfigs } from './ProcessDiscoveryButton/types';
import { fetchProcessDiscoveryData } from './customHooks/useProcessDiscoveryResults';
import eventBus from './helpers/EventBus';
import { open } from 'common/window_location';

interface CustomLinkRendererProps {
  formattedValue: string;
  processDiscoveryContext: ActionsConfigs;
  selectedActionForExistingColumn: string;
}

export const CustomLinkRenderer = ({
  formattedValue,
  processDiscoveryContext,
  selectedActionForExistingColumn,
}: CustomLinkRendererProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedUrl, setSelectedUrl] = useState<string>('');

  const onModalDismiss = () => {
    setShowModal(false);
  };

  const onClick = async (event: React.MouseEvent) => {
    const target = event.target as HTMLElement;

    // Only trigger if the user clicks directly on the .link-value div
    if (target.className !== 'link-value') {
      return;
    }

    try {
      eventBus.dispatch('VISUALIZATION_LOADING', true);
      const response = await fetchProcessDiscoveryData({
        contextParams: processDiscoveryContext,
      });
      const applicationDescriptors = get(response, '0.applicationDescriptors', []);
      const matchedDescriptor = applicationDescriptors.find(
        (descriptor: ApplicationDescriptor) => descriptor.id === selectedActionForExistingColumn,
      );

      if (hasEmbeddedExecutionMethod(matchedDescriptor)) {
        setSelectedUrl(matchedDescriptor?.url);
        setShowModal(true);
      } else {
        open(matchedDescriptor?.url, '_blank');
      }

      eventBus.dispatch('VISUALIZATION_LOADING', false);
    } catch (error) {
      eventBus.dispatch('VISUALIZATION_LOADING', false);
    }
  };

  return (
    <div className="link-value" onClick={onClick}>
      {formattedValue}
      {showModal && (
        <ProcessDiscoveryEmbedModal url={selectedUrl} onDismiss={onModalDismiss} showModal={showModal} />
      )}
    </div>
  );
};
